import { render, staticRenderFns } from "./Ylorganization.vue?vue&type=template&id=6b59e379&scoped=true&"
import script from "./Ylorganization.vue?vue&type=script&lang=ts&"
export * from "./Ylorganization.vue?vue&type=script&lang=ts&"
import style0 from "./Ylorganization.vue?vue&type=style&index=0&id=6b59e379&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b59e379",
  null
  
)

export default component.exports